import { pascalize } from 'humps';

export const FIRST_COLUMN_PREFIX = 'name_';

export const getFirstColumnKey = (entity: string) =>
  `${FIRST_COLUMN_PREFIX}${pascalize(entity)}`;
